define('usuario-default-controller',[
        'usuario-default-resource',
        // 'usuario-meus-imoveis-controller',
        'usuario-imoveis-favoritos-controller',
        'usuario-solicitacao-interesse-controller',
        'usuario-minha-conta-controller',
        'locatario-controller',
        'proprietario-controller',
        'chaves-controller',
        'atendimentos-controller',
        'contrato-controller',
        'contestacao-vistoria-controller',
        'esteira-locacao-controller',
        'matchmediang',
        'angular-diretivas-site',
        'angular-socialshare',
        'usuario-dashboard-controller',
        'angular-input-masks'], function() {
    var app = angular.module('usuario.default.controller', [
        'ngStorage',
        'usuario.default.resource',
        'usuario.dashboard.controller',
        // 'usuario.meus.imoveis.controller',
        'usuario.imoveis.favoritos.controller',
        'usuario.minha.conta.controller',
        'locatario.controller',
        'proprietario.controller',
        'chaves.controller',
        'atendimentos.controller',
        'contrato.controller',
        'contestacao.vistoria.controller',
        'esteira.locacao.controller',
        'usuario.solicitacao.interesse.controller'
    ]);


    app.controller('UsuarioDefaultController', ['$rootScope', '$scope', 'UsuarioDefault',  '$location', '$window',
        function($rootScope,  $scope, UsuarioDefault, $location, $window) {

        }
    ]);
});

